import api from './interceptor';
import {mainUrl} from './Urls';

interface TwoFactorStatusResponse {
	data: {
		provisioning_url: string;
	};
}

export const fetchTwoFactorStatusApi = async (): Promise<{data: TwoFactorStatusResponse}> => {
	const response = await api.get<TwoFactorStatusResponse>(mainUrl + '/auth/two-factor/setup/', {
		headers: {
			Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
		},
	});

	return response;
};

export const setupTwoFactorApi = async (code: string): Promise<{data: TwoFactorStatusResponse}> => {
	const response = await api.post(
		mainUrl + '/auth/two-factor/setup/',
		{
			verification_code: code,
		},
		{
			headers: {
				Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
			},
		}
	);
	return response;
};
